import Icon from "@mdi/react";
interface ButtonProps {
  descricaoBotao?: string;
  className?: string;
  onclick?: () => void;
  type?: "button" | "submit" | "reset" | undefined;
  icone?: string;
  children?: React.ReactNode;
  title?: string;
  disabled?: boolean;
  size?: number;
  style?: React.CSSProperties;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function Button({
  descricaoBotao,
  className,
  onclick,
  type,
  icone,
  children,
  title,
  disabled,
  size,
  style,
  onMouseDown,
}: ButtonProps) {
  return (
    <button
      className={className}
      type={type}
      onClick={onclick}
      onMouseDown={onMouseDown}
      title={title}
      disabled={disabled}
      style={style}
    >
      {icone && <Icon path={icone} size={size || 1} />} {descricaoBotao}
    </button>
  );
}
